import { WebRoutePath } from "../routes/routePath";
import ImagesUrl from "./images";
const webSidebarConfig = () => [
  {
    title: WebRoutePath.DASHBOARD.title,
    Icon: ImagesUrl.dashboard,
    path: WebRoutePath.DASHBOARD.path,
  },
  {
    title: WebRoutePath.GROWER_MANAGEMENT.title,
    Icon: ImagesUrl.grower,
    path: WebRoutePath.GROWER_MANAGEMENT.path,
  },
  {
    title: WebRoutePath.FIELD_MANAGEMENT.title,
    Icon: ImagesUrl.field,
    path: WebRoutePath.FIELD_MANAGEMENT.path,
  },
  {
    title: WebRoutePath.PRIVACY_POLICY.title,
    Icon: ImagesUrl.privacy,
    path: WebRoutePath.PRIVACY_POLICY.path,
  },
  {
    title: WebRoutePath.TERMS_CONDITIONS.title,
    Icon: ImagesUrl.terms,
    path: WebRoutePath.TERMS_CONDITIONS.path,
  },
  {
    title: WebRoutePath.ABOUT_US.title,
    Icon: ImagesUrl.about,
    path: WebRoutePath.ABOUT_US.path,
  },
];

export default webSidebarConfig;
